<template>
  <div class="progress">
    <div :style="{ width: `${progressPercent}%` }" class="progress-bar" role="progressbar"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    value: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    }
  },
  computed: {
    progressPercent() {
      return (this.value / this.max) * 100
    }
  }
}
</script>

<style scoped>
.progress {
  display: flex;
  height: 6px;
  margin: 0 0 16px;
  background-color: rgba(0, 0, 0, 0.04);
  border-radius: 3px;
  overflow: hidden;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  background-color: #3598db;
  transition: width 320ms ease-in-out;
}
</style>
